import React from "react";
import menuConfig from "../../configurations/menuConfig";
import PageTitle from "../common/pageTitle";
import QuickLinks from "./Quicklinks";

const DashboardPage = (...props) => (
      <div className="welcome-arbiter">
        <PageTitle title="Arbiter" />
        <hr />
        <h4>Quick Links</h4>
        <hr />
        <div className="row quick-links">
            {menuConfig.menus.map(menu => (
              <QuickLinks location={props.location} menu={menu} allowedPermissions={menu.permissions} key={menu.key} />
            ))}
        </div>
      </div>
    );

export default DashboardPage;


// WEBPACK FOOTER //
// ./src/components/dashboard/dashboardPage.js